// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bell16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell': IconBell;
    }
}

/**
 * The icon component for the 'bell' icon
 */
export class IconBell extends IconSvg {
    public constructor() {
        super(bell16X16);
    }
}

registerIconSvg('icon-bell', IconBell);
export const iconBellTag = 'nimble-icon-bell';
